export default {"src":"/_next/static/media/bulb.2abf0bc6.svg","height":10,"width":8,"blurWidth":0,"blurHeight":0};